import type {
  ColumnWidth,
  Kind,
  RowOf,
} from "src/pages/ad-studio/insights/performance/view/types";

export const WIDTHS: Record<
  ColumnWidth,
  { min: string; max: string | "no-max" }
> = {
  name: { min: "var(--chakra-sizes-52)", max: "no-max" },
  "short-text": {
    min: "var(--chakra-sizes-24)",
    max: "var(--chakra-sizes-40)",
  },
  badge: { min: "var(--chakra-sizes-20)", max: "var(--chakra-sizes-24)" },
  count: { min: "var(--chakra-sizes-16)", max: "var(--chakra-sizes-20)" },
  metric: { min: "var(--chakra-sizes-20)", max: "var(--chakra-sizes-28)" },
};

export const PINNED = {
  position: "sticky" as const,
  left: 0,
  bg: "white",
  borderRightWidth: "hairline",
  borderRightStyle: "solid",
  borderRightColor: "base.divider",
};

export const PRIMARY_KEYS: { [P in Kind]: keyof RowOf<P> } = {
  ads: "entityId",
  "ad-sets": "entityId",
  campaigns: "entityId",
  groups: "id",
};
